import EventDetail from "../../../events/interfaces/EventDetail";
import { EventActions, EventTypes } from "../../actions";
import { DUEventInfo } from "../../initialState";

export const eventReducer = (state: DUEventInfo, action: EventActions) => {
  const types: Array<string> = Object.values(EventTypes);
  const myType = types.includes(action.type);
  if (myType) {
    if (action.type === EventTypes.SetDetails.toString()) {
      return {
        ...state,
        currentEventDetail: { ...(action.payload as EventDetail) },
      };
    }
    return {
      ...state,
      ...action.payload,
    };
  } else {
    return state;
  }
};
